.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.topbar {
  height: var(--kh-topbar-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: #ed1943;
  position: sticky;
  top: 0;
  z-index: 50;
}

.topbarLeft {
  display: flex;
  align-items: center;
}

.topbarRight {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wordmark {
  font-family: var(--kh-font);
  font-size: var(--kh-size-wordmark);
  font-weight: var(--kh-font-wordmark);
  letter-spacing: var(--kh-ls-wordmark);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 7px;
}

.wordmarkCrown {
  position: relative;
  top: 0px;
  color: #ffffff;
  flex-shrink: 0;
}

.wordmarkPrimary {
  color: #ffffff;
}

.serverOfflineChip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(239, 68, 68, 0.25);
  border: 0.5px solid rgba(239, 68, 68, 0.5);
  color: #fff;
  font-size: var(--kh-size-meta);
  white-space: nowrap;
  cursor: help;
}

.serverOfflineDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
  flex-shrink: 0;
}

.avatarWrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.userAvatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  padding: 0;
  overflow: hidden;
  transition: box-shadow var(--kh-duration-fast);
}

.userAvatar:hover {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

.avatarImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.avatarPopover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  min-width: 140px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.avatarPopoverItem {
  display: block;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.8rem;
  text-align: left;
  cursor: pointer;
  transition: background 0.1s;
}

.avatarPopoverItem:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.avatarFileInput {
  display: none;
}

.wordmarkLink {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
}

.avatarPopoverDivider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 0;
}

.portalsLink {
  color: #ffffff;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  transition: opacity 0.15s;
}

.portalsLink:hover {
  opacity: 0.8;
}

.shellMain {
  flex: 1;
}

.grainientBg {
  position: fixed;
  inset: 0;
  z-index: -1;
  overflow: hidden;
}
